import { createContext, RefObject, useContext } from 'react';

interface IPortalContainerContextValue {
  portalContainerRef?: RefObject<HTMLElement>;
}

const portalContainerContext = createContext<IPortalContainerContextValue>({});

export const usePortalContainer = (): IPortalContainerContextValue => {
  const { portalContainerRef } = useContext(portalContainerContext);

  return {
    portalContainerRef,
  };
};

export const PortalContainerContextProvider = portalContainerContext.Provider;
